import styled, { css } from 'styled-components'

export const RadioButtonContainer = styled.div<{ hasError?: boolean }>`
  display: flex;
  align-items: center;

  input {
    border: 2px solid #4b4b4b;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    appearance: none;
    cursor: pointer;

    &::before {
      content: "";
      display: inline-block;
      width: 60%;
      height: 60%;
      border-radius: 50%;
      margin-right: 5px;
      background-color: #1f35b5;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
    }

    &:checked::before {
      opacity: 1;
    }

    ${({ hasError }) =>
    hasError &&
      css`
        border: 2px solid #ff4949;
      `}
  }

  input:checked {
    border: 2px solid #1f35b5;
  }

  label {
    margin-left: 5px;
    cursor: pointer;
  }
`
